<script setup lang="ts">
import { onMounted } from "vue";
import { useRouter } from "vue-router";

import SkoreSpinner from "@/components/ui/SkoreSpinner.vue";
import FullPageCenteredLayout from "@/layouts/FullPageCenteredLayout.vue";
import { RouteNames } from "@/router";
import { useApi } from "@/services/api";

const router = useRouter();
const api = useApi();

onMounted(async () => {
  await api.logout();
  router.replace({ name: RouteNames.Dispatch });
});
</script>

<template>
  <FullPageCenteredLayout>
    <template #title>Logout in progress.</template>

    <main class="logout">
      <SkoreSpinner />
    </main>
  </FullPageCenteredLayout>
</template>

<style scoped>
.logout {
  text-align: center;
}
</style>
